import React, { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { RootState } from '../../../store/rootReducer';
import CessationCard from '../../common/CessationCard';
import Loader from '../../common/Loader';
import DealPaymentBankDetails from './components/BankDetails';
import DealInfoOnDealPayment from './components/DealInfo';
import PaymentUpload from './components/PaymentUpload';
import DealPaymentActions from './redux/actions';

const DealPayment: React.FC = () => {
    let uuid = useParams().uuid;
    const dispatch = useDispatch();

    const bankAccount = useSelector((state: RootState) => state.dealPayment.payment?.deal.bankAccount);
    const loading = useSelector((state: RootState) => state.dealPayment.loading);

    useLayoutEffect(() => {
        if (uuid) {
            dispatch(DealPaymentActions.getDealPaymentReq(uuid));
        }
    }, [dispatch, uuid]);

    return (
        <div>
            {!loading && (
                <div className="w-full pt-4">
                    <p className="mt-6 mb-6 w-full text-center sm:text-center md:text-left page_title">Deal Payment</p>
                    <DealInfoOnDealPayment />
                    {bankAccount && (
                        <div className="flex flex-col mt-4 md:flex-row">
                            <div className="w-full sm:w-full md:w-7/12 pt-2 pb-2 md:pr-2">
                                <DealPaymentBankDetails />
                            </div>
                            <div className="w-full sm:w-full md:w-6/12 pt-2 pb-2 md:pl-2">
                                <PaymentUpload />
                            </div>
                        </div>
                    )}
                    <CessationCard />
                </div>
            )}
            {loading && (
                <div className="flex justify-center items-center">
                    <Loader />
                </div>
            )}
        </div>
    );
};

export default DealPayment;
